export const SET_SNACKBAR = 'SET_SNACKBAR'
export const SET_SUCCESS_NOTIFICATION = 'SET_SUCCESS_NOTIFICATION'
